export function mutateString(
  wholeString: string,
  dataToReplace: { [key: string]: string },
) {
  let modifiedString = wholeString;
  Object.keys(dataToReplace).map((key: string) => {
    const value = dataToReplace[key];
    if (value) {
      modifiedString = modifiedString.replace(key, value);
    }
  });
  return modifiedString;
}
